module.exports = __webpack_public_path__ + "img/email.fb3ebf3e.png";